import React from "react";
import "./styles.scss";

function QuizAnswers({ answers, onAnswer, questionId }) {
  return (
    <div className="buttons is-centered">
      {answers.map(answer => (
        <button
          key={`${questionId}-${answer.id}}`}
          className="button is-normal is-outlined is-primary"
          onClick={() => onAnswer(answer.id)}
        >
          {answer.text}
        </button>
      ))}
    </div>
  );
}

export default QuizAnswers;
